import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class DaDataAddressSuggestionDto
*  Подсказка улицы/дома для витрины и админки (без города в Services.DaData.DaDataAddressSuggestionDto.Label).
*/
export class DaDataAddressSuggestionDto extends ActiveModel {

/**
  * label
  * 
  */
  @ActiveField('')
  label: string = ''


/**
  * street
  * 
  */
  @ActiveField()
  street?: null | string


/**
  * house
  * 
  */
  @ActiveField()
  house?: null | string


/**
  * postalCode
  * 
  */
  @ActiveField()
  postalCode?: null | string


  /**
  * lat
  *   */
  @ActiveField()
  lat?: null | number


  /**
  * lon
  *   */
  @ActiveField()
  lon?: null | number
}
